/**
 * usePageTracking — fires a `page_view` analytics event on every route change.
 *
 * Must be called from inside a component that is mounted inside BrowserRouter
 * (i.e. a component rendered inside the <Router> tree).
 */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackEvent } from '@/lib/analytics'

export function usePageTracking(): void {
  const location = useLocation()

  useEffect(() => {
    // Fire-and-forget — errors are caught inside trackEvent
    trackEvent('page_view', {
      properties: { path: location.pathname },
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])
}
